import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ModalEquipmentCategoryEditComponent} from './modal-equipment-category-edit.component';
import {ReactiveFormsModule} from "@angular/forms";
import {FieldModule} from "../../inputs/field/field.module";
import {ButtonModule} from "../../buttons/button/button.module";

@NgModule({
  declarations: [
    ModalEquipmentCategoryEditComponent
  ],
  exports: [
    ModalEquipmentCategoryEditComponent
  ],
  imports: [
    FieldModule,
    CommonModule,
    ButtonModule,
    ReactiveFormsModule
  ]
})
export class ModalEquipmentCategoryEditModule {
}
